import moment from "moment";
import {
  ORGANIZATION_BASE_URL,
  WAR_ASSESSMENT_Details_URL,
  WAR_ASSESSMENT_LIST_URL,
  WAR_ASSESSMENT_METADATA_URL,
} from "../../config/service";
import { getStorage, setStorage } from "../helpers/storage";
import {
  AcmeAppDev_Workload_Check_Performace_Efficiency_MockData,
  AcmeAppDev_Workload_Checks_Security_Mockdata,
  AcmeAppDev_Workload_Checks_Summary_MockData,
  AcmeAppDev_Workload_CostOptimization_Checks_MockData,
  AcmeAppDev_Workload_Operational_Excellence_Checks_MockData,
  AcmeAppDev_Workload_Reliability_Checks_MockData,
  AcmeAppDev_Workload_Sustainability_Checks_MockData,
  Comleted_Workload_List_Response,
  Cost_Optimization_Q1,
  Cost_Optimization_Q10,
  Cost_Optimization_Q10_ExecutionStatus,
  Cost_Optimization_Q11,
  Cost_Optimization_Q11_ExecutionStatus,
  Cost_Optimization_Q1_Answer_Summaries,
  Cost_Optimization_Q1_Summaries,
  Cost_Optimization_Q2,
  Cost_Optimization_Q2_ExecutionStatus,
  Cost_Optimization_Q3,
  Cost_Optimization_Q3_ExecutionStatus,
  Cost_Optimization_Q4,
  Cost_Optimization_Q4_ExecutionStatus,
  Cost_Optimization_Q5,
  Cost_Optimization_Q5_ExecutionStatus,
  Cost_Optimization_Q6,
  Cost_Optimization_Q6_ExecutionStatus,
  Cost_Optimization_Q7,
  Cost_Optimization_Q7_ExecutionStatus,
  Cost_Optimization_Q8,
  Cost_Optimization_Q8_ExecutionStatus,
  Cost_Optimization_Q9,
  Cost_Optimization_Q9_ExecutionStatus,
  Day2_Context_MockData,
  Edit_Workload_Acc_Details,
  Edit_Workload_Summaries,
  Edit_Workload_Summaries_Metadata,
  Operational_Excellence_Q1,
  Operational_Excellence_Q10,
  Operational_Excellence_Q10_ExecutionStatus,
  Operational_Excellence_Q11,
  Operational_Excellence_Q11_ExecutionStatus,
  Operational_Excellence_Q1_ExecutionStatus,
  Operational_Excellence_Q1_Summaries,
  Operational_Excellence_Q2,
  Operational_Excellence_Q2_ExecutionStatus,
  Operational_Excellence_Q3,
  Operational_Excellence_Q3_ExecutionStatus,
  Operational_Excellence_Q4,
  Operational_Excellence_Q4_ExecutionStatus,
  Operational_Excellence_Q5,
  Operational_Excellence_Q5_ExecutionStatus,
  Operational_Excellence_Q6,
  Operational_Excellence_Q6_ExecutionStatus,
  Operational_Excellence_Q7,
  Operational_Excellence_Q7_ExecutionStatus,
  Operational_Excellence_Q8,
  Operational_Excellence_Q8_ExecutionStatus,
  Operational_Excellence_Q9,
  Operational_Excellence_Q9_ExecutionStatus,
  Performance_Efficiency_Check_Q1_ExecutionStatus,
  Performance_Efficiency_Check_Q2_ExecutionStatus,
  Performance_Efficiency_Check_Q3_ExecutionStatus,
  Performance_Efficiency_Check_Q5_ExecutionStatus,
  Performance_Efficiency_Check_Q6_ExecutionStatus,
  Performance_Efficiency_Check_Q7_ExecutionStatus,
  Performance_Efficiency_Check_Q8_ExecutionStatus,
  Performance_Efficiency_Q1,
  Performance_Efficiency_Q1_Summaries,
  Performance_Efficiency_Q2,
  Performance_Efficiency_Q3,
  Performance_Efficiency_Q4_Answer_Summaries,
  Performance_Efficiency_Q4_Summaries,
  Performance_Efficiency_Q5,
  Performance_Efficiency_Q6,
  Performance_Efficiency_Q7,
  Performance_Efficiency_Q8,
  Reliability_Check_Q10_ExecutionStatus,
  Reliability_Check_Q11_ExecutionStatus,
  Reliability_Check_Q12_ExecutionStatus,
  Reliability_Check_Q13_ExecutionStatus,
  Reliability_Check_Q2_ExecutionStatus,
  Reliability_Check_Q3_ExecutionStatus,
  Reliability_Check_Q4_ExecutionStatus,
  Reliability_Check_Q5_ExecutionStatus,
  Reliability_Check_Q6_ExecutionStatus,
  Reliability_Check_Q7_ExecutionStatus,
  Reliability_Check_Q8_ExecutionStatus,
  Reliability_Check_Q9_ExecutionStatus,
  Reliability_Q1,
  Reliability_Q10,
  Reliability_Q11,
  Reliability_Q12,
  Reliability_Q13,
  Reliability_Q1_Answer_Summaries,
  Reliability_Q1_Summaries,
  Reliability_Q2,
  Reliability_Q3,
  Reliability_Q4,
  Reliability_Q5,
  Reliability_Q6,
  Reliability_Q7,
  Reliability_Q8,
  Reliability_Q9,
  Save_Milestone_Data,
  Security_Check_Execution_Status,
  Security_Check_Execution_Status_Q11,
  Security_Check_Q10_ExecutionStatus,
  Security_Check_Q2_ExecutionStatus,
  Security_Check_Q2_Summaries,
  Security_Check_Q3_ExecutionStatus,
  Security_Check_Q4ExecutionStatus,
  Security_Check_Q5_ExecutionStatus,
  Security_Check_Q6_ExecutionStatus,
  Security_Check_Q7_ExecutionStatus,
  Security_Check_Q8_ExecutionStatus,
  Security_Check_Q9_ExecutionStatus,
  Security_Metadata_MockData,
  Security_MockData_Securely_Operate,
  Security_Pillar_Q10,
  Security_Pillar_Q11,
  Security_Pillar_Q2,
  Security_Pillar_Q3,
  Security_Pillar_Q4,
  Security_Pillar_Q5,
  Security_Pillar_Q6,
  Security_Pillar_Q7,
  Security_Pillar_Q8,
  Security_Pillar_Q9,
  Security_Question_List,
  Sustainability_Check_Q2_ExecutionStatus,
  Sustainability_Check_Q3_ExecutionStatus,
  Sustainability_Check_Q4_ExecutionStatus,
  Sustainability_Check_Q5_ExecutionStatus,
  Sustainability_Check_Q6_ExecutionStatus,
  Sustainability_Q1,
  Sustainability_Q1_Answer_Summaries,
  Sustainability_Q1_Summaries,
  Sustainability_Q2,
  Sustainability_Q3,
  Sustainability_Q4,
  Sustainability_Q5,
  Sustainability_Q6,
  Workload_Check_Performace_Efficiency_MockData,
  Workload_Checks_Security_Mockdata,
  Workload_Checks_Summary_MockData,
  Workload_CostOptimization_Checks_MockData,
  Workload_Count_Summary_MockData,
  Workload_Limit_MockData,
  Workload_List_Response,
  Workload_MetaData_MockData,
  Workload_Operational_Excellence_Checks_MockData,
  Workload_Reliability_Checks_MockData,
  Workload_Sustainability_Checks_MockData
} from "../mockData/wafr-api-mock-data";
import {
  CARD_PILLAR,
  CARD_QUESTION,
  CARD_WORKLOAD,
  COST_Q4_DECOMISSIONING_RESOURCES,
  COST_Q5_SELECT_SERVICE,
  COST_Q9_MANAGE_DEMAND_RESOURCES,
  OPERATIONAL_Q10_EVENT_RESPONSE,
  OPERATIONAL_Q4_TELEMETRY,
  OPERATIONAL_Q5_DEV_INTEG,
  OPERATIONAL_Q8_WORKLOAD_HEALTH,
  PENDING_WORKLOAD_ID,
  PERFORMANCE_Q1_PERFORMING_ARCHITECTURE,
  PERFORMANCE_Q6_CONTINUE_HAVING_APPROPRIATE_RESOURCE_TYPE,
  PERFORMANCE_Q7_MONITOR_INSTANCES_POST_LAUNCH,
  RELIABILITY_Q10_FAULT_ISOLATION,
  RELIABILITY_Q11_WITHSTAND_COMPONENT_FAILURES,
  RELIABILITY_Q2_PLANNING_NETWORK_TOPOLOGY,
  RELIABILITY_Q3_SERVICE_ARCHITECTURE,
  RELIABILITY_Q5_MITIGATE_INTERACTION_FAILURE,
  RELIABILITY_Q6_MONITOR_AWS_RESOURCES,
  RELIABILITY_Q9_BACKING_UP_DATA,
  SECURITY_Q1_SECURELY_OPERATE_QUESTION_ID,
  SECURITY_Q2_IDENTITIES_QUESTION_ID,
  SECURITY_Q3_PERMISSIONS_QUESTION_ID,
  SECURITY_Q4_DETECT_INVESTIGATE_EVENTS_ID,
  SECURITY_Q5_NETWORK_PROTECTION_ID,
  SECURITY_Q6_PROTECT_COMPUTE_ID,
  SECURITY_Q7_DATA_CLASSIFICATION_ID,
  SECURITY_Q8_PROTECT_DATA_REST,
  SECURITY_Q9_PROTECT_DATA_TRANSIT,
  SUSTAINABILITY_Q2_SUS_USER,
  SUSTAINABILITY_Q3_SUS_SOFTWARE,
  SUSTAINABILITY_Q4_SUS_DATA,
} from "./wafr-services-constants";

import {
  NewWorkload_Check_Performace_Efficiency_MockData,
  NewWorkload_Checks_Security_Mockdata,
  NewWorkload_Checks_Summary_MockData,
  NewWorkload_CostOptimization_Checks_MockData,
  NewWorkload_Cost_Optimization_Q1,
  NewWorkload_Cost_Optimization_Q10,
  NewWorkload_Cost_Optimization_Q11,
  NewWorkload_Cost_Optimization_Q2,
  NewWorkload_Cost_Optimization_Q3,
  NewWorkload_Cost_Optimization_Q4,
  NewWorkload_Cost_Optimization_Q5,
  NewWorkload_Cost_Optimization_Q6,
  NewWorkload_Cost_Optimization_Q7,
  NewWorkload_Cost_Optimization_Q8,
  NewWorkload_Cost_Optimization_Q9,
  NewWorkload_Cost_Optimization_Question_List,
  NewWorkload_Operational_Excellence_Checks_MockData,
  NewWorkload_Operational_Excellence_Q1,
  NewWorkload_Operational_Excellence_Q10,
  NewWorkload_Operational_Excellence_Q11,
  NewWorkload_Operational_Excellence_Q2,
  NewWorkload_Operational_Excellence_Q3,
  NewWorkload_Operational_Excellence_Q4,
  NewWorkload_Operational_Excellence_Q5,
  NewWorkload_Operational_Excellence_Q6,
  NewWorkload_Operational_Excellence_Q7,
  NewWorkload_Operational_Excellence_Q8,
  NewWorkload_Operational_Excellence_Q9,
  NewWorkload_Operational_Excellence_Question_List,
  NewWorkload_Performance_Eff_Q1,
  NewWorkload_Performance_Eff_Q2,
  NewWorkload_Performance_Eff_Q3,
  NewWorkload_Performance_Eff_Q4,
  NewWorkload_Performance_Eff_Q5,
  NewWorkload_Performance_Eff_Q6,
  NewWorkload_Performance_Eff_Q7,
  NewWorkload_Performance_Eff_Q8,
  NewWorkload_Performance_Eff_Question_List,
  NewWorkload_Question_Check_MockData,
  NewWorkload_Reliability_Checks_MockData,
  NewWorkload_Reliability_Q1,
  NewWorkload_Reliability_Q10,
  NewWorkload_Reliability_Q11,
  NewWorkload_Reliability_Q12,
  NewWorkload_Reliability_Q13,
  NewWorkload_Reliability_Q2,
  NewWorkload_Reliability_Q3,
  NewWorkload_Reliability_Q4,
  NewWorkload_Reliability_Q5,
  NewWorkload_Reliability_Q6,
  NewWorkload_Reliability_Q7,
  NewWorkload_Reliability_Q8,
  NewWorkload_Reliability_Q9,
  NewWorkload_Reliability_Question_List,
  NewWorkload_Security_Q1,
  NewWorkload_Security_Q10,
  NewWorkload_Security_Q11,
  NewWorkload_Security_Q2,
  NewWorkload_Security_Q3,
  NewWorkload_Security_Q4,
  NewWorkload_Security_Q5,
  NewWorkload_Security_Q6,
  NewWorkload_Security_Q7,
  NewWorkload_Security_Q8,
  NewWorkload_Security_Q9,
  NewWorkload_Security_Question_List,
  NewWorkload_Sustainability_Checks_MockData,
  NewWorkload_Sustainability_Q1,
  NewWorkload_Sustainability_Q2,
  NewWorkload_Sustainability_Q3,
  NewWorkload_Sustainability_Q4,
  NewWorkload_Sustainability_Q5,
  NewWorkload_Sustainability_Q6,
  NewWorkload_Sustainability_Question_List,
} from "../mockData/wafr-api-new-mock-data";

import {
  No_Findings_Data,
  Security_Q1_Check_Details,
  Security_Q2_Check_Details,
  Security_Q3_Check_Details,
  Security_Q4_Check_Details,
  Security_Q5_Check_Details,
  Security_Q6_Check_Details,
  Security_Q7_Check_Details,
  Security_Q8_Check_Details,
  Security_Q9_Check_Details,
  securityCheckFindings,
} from "../mockData/wafr-checks/securityChecks";

import { createReview, updateReview } from "../factories/assessments";
import {
  PerformanceCheckFindings,
  Performance_Q1_Check_Details,
  Performance_Q6_Check_Details,
  Performance_Q7_Check_Details,
} from "../mockData/wafr-checks/perfromanceChecks";

import { getReportExports } from "../factories";
import {faker}  from "@faker-js/faker";
import {
  Cost_Q4_Check_Details,
  Cost_Q5_Check_Details,
  Cost_Q6_Check_Details,
  costCheckFindings,
} from "../mockData/wafr-checks/costChecks";
import {
  Operational_Q10_Check_Details,
  Operational_Q4_Check_Details,
  Operational_Q5_Check_Details,
  Operational_Q8_Check_Details,
  operationalCheckFindings,
} from "../mockData/wafr-checks/operationalChecks";
import {
  Reliability_Q10_Check_Details,
  Reliability_Q11_Check_Details,
  Reliability_Q2_Check_Details,
  Reliability_Q3_Check_Details,
  Reliability_Q5_Check_Details,
  Reliability_Q6_Check_Details,
  Reliability_Q9_Check_Details,
  reliabilityCheckFindings,
} from "../mockData/wafr-checks/reliabilityChecks";
import {
  Sustainability_Q2_Check_Details,
  Sustainability_Q3_Check_Details,
  Sustainability_Q4_Check_Details,
  sustainabilityCheckFindings,
} from "../mockData/wafr-checks/sustainabilityChecks";
import {
  AcmeApp_Dev_MOCK,
  AcmeApp_Dev_WorkloadId,
  AcmeApp_Prod_MOCK,
  AcmeApp_Prod_WorkloadId,
  AcmeApp_Staging_MOCK,
  AcmeApp_Staging_WorkloadId,
  Acme_Research_App_Mock,
  Acme_Research_App_WorkloadId,
} from "../mockData/wafr-workload-details-mock";

export const setUpWafrServices = (mock) => {
  mock.onGet("/war-assessment/workload_count_summary").reply(async () => {
    let assessments = await getStorage("ASSESSMENTS");
    let pendingCount = 1;
    if (assessments) {
      pendingCount = assessments.WorkloadSummaries.length;
    }

    return [200, Workload_Count_Summary_MockData(pendingCount)];
  });

  mock
    .onGet(
      `${WAR_ASSESSMENT_LIST_URL}?Filters=%7B%22Status%22:%22PENDING%22%7D&Limit=10&PageNumber=1`
    )
    .reply(async () => {
      let assessments = await getStorage("ASSESSMENTS");

      if (!assessments) {
        assessments = Workload_List_Response;
      }

      await setStorage("ASSESSMENTS", assessments);

      return [200, assessments];
    });

  mock
    .onGet(`/scheduler/jobs?Day2Context=WAR-ASSESSMENT::${PENDING_WORKLOAD_ID}`)
    .reply(() => {
      return [200, Day2_Context_MockData];
    });

  mock.onGet(`${WAR_ASSESSMENT_Details_URL}metadata`).reply(() => {
    return [200, Workload_MetaData_MockData];
  });

  const assessmentWorkloadMilestonesEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/milestones`
  );

  mock.onGet(assessmentWorkloadMilestonesEndpoint).reply(() => {
    return [200, Workload_Limit_MockData];
  });

  const assessmentWorkloadSharesEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/shares`
  );
  mock.onGet(assessmentWorkloadSharesEndpoint).reply(() => {
    return [200, []];
  });

  mock.onGet(`${WAR_ASSESSMENT_Details_URL}metadata`).reply(() => {
    return [200, Security_Metadata_MockData];
  });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22securely-operate%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Execution_Status];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22application-security%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Execution_Status_Q11];
    });

  const assessmentWorkloadChecksDetailsSummaryEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/check-details-summary`
  );

  mock.onGet(assessmentWorkloadChecksDetailsSummaryEndpoint).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let completeFilterParams = JSON.parse(
      decodeURI(config.url.split("Filters=")[1])
    );

    const isPendingId = id === PENDING_WORKLOAD_ID;

    const checksMap = {
      [SECURITY_Q1_SECURELY_OPERATE_QUESTION_ID]: Security_Q1_Check_Details,
      [SECURITY_Q2_IDENTITIES_QUESTION_ID]: Security_Q2_Check_Details,
      [SECURITY_Q3_PERMISSIONS_QUESTION_ID]: Security_Q3_Check_Details,
      [SECURITY_Q4_DETECT_INVESTIGATE_EVENTS_ID]: Security_Q4_Check_Details,
      [SECURITY_Q5_NETWORK_PROTECTION_ID]: Security_Q5_Check_Details,
      [SECURITY_Q6_PROTECT_COMPUTE_ID]: Security_Q6_Check_Details,
      [SECURITY_Q7_DATA_CLASSIFICATION_ID]: Security_Q7_Check_Details,
      [SECURITY_Q8_PROTECT_DATA_REST]: Security_Q8_Check_Details,
      [SECURITY_Q9_PROTECT_DATA_TRANSIT]: Security_Q9_Check_Details,
      [PERFORMANCE_Q1_PERFORMING_ARCHITECTURE]: Performance_Q1_Check_Details,
      [PERFORMANCE_Q6_CONTINUE_HAVING_APPROPRIATE_RESOURCE_TYPE]:
        Performance_Q6_Check_Details,

      [PERFORMANCE_Q7_MONITOR_INSTANCES_POST_LAUNCH]:
        Performance_Q7_Check_Details,
      [SUSTAINABILITY_Q2_SUS_USER]: Sustainability_Q2_Check_Details,
      [SUSTAINABILITY_Q3_SUS_SOFTWARE]: Sustainability_Q3_Check_Details,
      [SUSTAINABILITY_Q4_SUS_DATA]: Sustainability_Q4_Check_Details,
      [RELIABILITY_Q2_PLANNING_NETWORK_TOPOLOGY]: Reliability_Q2_Check_Details,
      [RELIABILITY_Q3_SERVICE_ARCHITECTURE]: Reliability_Q3_Check_Details,
      [RELIABILITY_Q5_MITIGATE_INTERACTION_FAILURE]:
        Reliability_Q5_Check_Details,
      [RELIABILITY_Q6_MONITOR_AWS_RESOURCES]: Reliability_Q6_Check_Details,
      [RELIABILITY_Q9_BACKING_UP_DATA]: Reliability_Q9_Check_Details,
      [RELIABILITY_Q10_FAULT_ISOLATION]: Reliability_Q10_Check_Details,
      [RELIABILITY_Q11_WITHSTAND_COMPONENT_FAILURES]:
        Reliability_Q11_Check_Details,
      [COST_Q4_DECOMISSIONING_RESOURCES]: Cost_Q4_Check_Details,
      [COST_Q5_SELECT_SERVICE]: Cost_Q5_Check_Details,
      [COST_Q9_MANAGE_DEMAND_RESOURCES]: Cost_Q6_Check_Details,
      [OPERATIONAL_Q4_TELEMETRY]: Operational_Q4_Check_Details,
      [OPERATIONAL_Q5_DEV_INTEG]: Operational_Q5_Check_Details,
      [OPERATIONAL_Q8_WORKLOAD_HEALTH]: Operational_Q8_Check_Details,
      [OPERATIONAL_Q10_EVENT_RESPONSE]: Operational_Q10_Check_Details,
    };

    if (isPendingId) {
      let response = checksMap[completeFilterParams.QuestionId]
        ? checksMap[completeFilterParams.QuestionId]
        : [];

      return [200, response];
    } else {
      return [200, []];
    }
  });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22identities%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q2_ExecutionStatus];
    });

  mock
    .onGet(`${WAR_ASSESSMENT_Details_URL}40dc23f165942b4c943e9b37cbddd0a`)
    .reply(() => {
      return [200, Security_Check_Q2_Summaries];
    });

  const assessmentWorkloadAnswerEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/answer`
  );
  mock.onPost(assessmentWorkloadAnswerEndpoint).reply(() => {
    return [200];
  });

  //Question 3

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22permissions%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q3_ExecutionStatus];
    });

  //Question 4

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22detect-investigate-events%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q4ExecutionStatus];
    });

  //Question 5

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22network-protection%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q5_ExecutionStatus];
    });

  //Question 6

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22protect-compute%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q6_ExecutionStatus];
    });

  //Question 7

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22data-classification%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q7_ExecutionStatus];
    });

  //Question 8

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22protect-data-rest%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q8_ExecutionStatus];
    });

  //Question 9

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22protect-data-transit%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q9_ExecutionStatus];
    });

  //Question 10

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22incident-response%22,%22PillarId%22:%22security%22%7D`
    )
    .reply(() => {
      return [200, Security_Check_Q10_ExecutionStatus];
    });

  //Question 1 Performance eff

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22performing-architecture%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Q1_Summaries];
    });

  //Question 2

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22select-compute%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Check_Q2_ExecutionStatus];
    });

  //Question 3

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22right-storage-solution%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Check_Q3_ExecutionStatus];
    });

  //Question 4

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22right-database-solution%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Q4_Answer_Summaries];
    });

  // //Question 5

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22select-network%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Check_Q5_ExecutionStatus];
    });

  // //Question 6

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22continue-having-appropriate-resource-type%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Check_Q6_ExecutionStatus];
    });

  // //Question 7

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22monitor-instances-post-launch%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Check_Q7_ExecutionStatus];
    });

  // //Question 8

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22tradeoffs-performance%22,%22PillarId%22:%22performance%22%7D`
    )
    .reply(() => {
      return [200, Performance_Efficiency_Check_Q8_ExecutionStatus];
    });

  //Sustainability Q1

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22sus_region%22,%22PillarId%22:%22sustainability%22%7D`
    )
    .reply(() => {
      return [200, Sustainability_Q1_Answer_Summaries];
    });

  // Q2

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22sus_user%22,%22PillarId%22:%22sustainability%22%7D`
    )
    .reply(() => {
      return [200, Sustainability_Check_Q2_ExecutionStatus];
    });

  // Q3

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22sus_software%22,%22PillarId%22:%22sustainability%22%7D`
    )
    .reply(() => {
      return [200, Sustainability_Check_Q3_ExecutionStatus];
    });

  // Q4

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22sus_data%22,%22PillarId%22:%22sustainability%22%7D`
    )
    .reply(() => {
      return [200, Sustainability_Check_Q4_ExecutionStatus];
    });

  // Q5

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22sus_hardware%22,%22PillarId%22:%22sustainability%22%7D`
    )
    .reply(() => {
      return [200, Sustainability_Check_Q5_ExecutionStatus];
    });

  // Q6

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22sus_dev%22,%22PillarId%22:%22sustainability%22%7D`
    )
    .reply(() => {
      return [200, Sustainability_Check_Q6_ExecutionStatus];
    });

  const findingsReportEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/findings/report`
  );

  mock.onGet(findingsReportEndpoint).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    if (isPendingId) {
      let reportExports = await getStorage("REPORT_EXPORTS");
      if (!reportExports) {
        reportExports = getReportExports();
      }

      reportExports.push({
        ReportId: faker.number.int(),
        ReportType: "WarAssessment",
        Status: "Success",
        Metadata: {
          Heading:
            "Well-Architected Review - Assessment Report - HumanTech Production Workload",
          ReportPath: "wafr-report",
        },
        CreatedAt: moment(),
        ExportFormat: "PDF",
      });

      reportExports.push({
        ReportId: faker.number.int(),
        ReportType: "WorkloadFindings",
        Metadata: {
          Heading:
            "Well-Architected Review - Findings Report - HumanTech Production Workload",
          ReportPath: "wafr-report",
        },
        Status: "Success",
        CreatedAt: moment(),
        ExportFormat: "CSV_DATA",
      });

      await setStorage("REPORT_EXPORTS", reportExports);
    }

    return [
      200,
      {
        ReportId: "a96240d5-6e06-4b2b-a724-8b4f37675218",
      },
    ];
  });

  const findingsEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/findings`
  );

  mock.onGet(findingsEndpoint).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let completeFilterParams = JSON.parse(
      decodeURI(config.url.split("Filters=")[1])
    );

    const isPendingId = id === PENDING_WORKLOAD_ID;

    if (isPendingId) {
      const findingsMap = {
        ...securityCheckFindings,
        ...PerformanceCheckFindings,
        ...sustainabilityCheckFindings,
        ...reliabilityCheckFindings,
        ...costCheckFindings,
        ...operationalCheckFindings,
      };

      const findingId = `${completeFilterParams.QuestionIds}_${completeFilterParams.CheckIds}`;

      let response = findingsMap[findingId]
        ? findingsMap[findingId]
        : No_Findings_Data;

      return [200, response];
    } else {
      return [200, No_Findings_Data];
    }
  });

  // re run checks
  mock.onPost(`${WAR_ASSESSMENT_Details_URL}check-executions`).reply(() => {
    return [200];
  });

  const assessmentWorkloadShareEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/share`
  );

  //share workload
  mock.onPost(assessmentWorkloadShareEndpoint).reply(() => {
    return [200];
  });

  const assessmentWorkloadMilestoneEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/milestone`
  );

  // save milestone
  mock.onPost(assessmentWorkloadMilestoneEndpoint).reply(() => {
    return [200];
  });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/milestones?PageNumber=1&Limit=10`
    )
    .reply(() => {
      return [200, Save_Milestone_Data];
    });

  //improvment status API
  mock
    .onPut(`${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}`)
    .reply(() => {
      return [
        200,
        {
          Message: "Review updated successfully.",
          Status: "Success",
        },
      ];
    });

  // create Review
  mock.onPost(`${WAR_ASSESSMENT_Details_URL}`).reply(() => {
    return [
      200,
      {
        Message: "Review updated successfully.",
        Status: "Success",
      },
    ];
  });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22manage-service-limits%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Q1_Answer_Summaries];
    });

  //Q2

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22planning-network-topology%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q2_ExecutionStatus];
    });

  //Q3

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22service-architecture%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q3_ExecutionStatus];
    });

  //Q4

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22prevent-interaction-failure%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q4_ExecutionStatus];
    });

  //Q5

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22mitigate-interaction-failure%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q5_ExecutionStatus];
    });

  //Q6

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22monitor-aws-resources%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q6_ExecutionStatus];
    });

  //Q7

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22adapt-to-changes%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q7_ExecutionStatus];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22tracking-change-management%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q8_ExecutionStatus];
    });

  //Q9

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22backing-up-data%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q9_ExecutionStatus];
    });

  //Q10

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22fault-isolation%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q10_ExecutionStatus];
    });

  //Q11

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22withstand-component-failures%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q11_ExecutionStatus];
    });

  //Q12

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22testing-resiliency%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q12_ExecutionStatus];
    });

  //Q13

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22planning-for-recovery%22,%22PillarId%22:%22reliability%22%7D`
    )
    .reply(() => {
      return [200, Reliability_Check_Q13_ExecutionStatus];
    });

  //cost optimizaion
  // Q1

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/questions?Filters=%7B%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q1];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22cloud-financial-management%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q1_Answer_Summaries];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22govern-usage%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q2_ExecutionStatus];
    });

  //Q3

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22monitor-usage%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q3_ExecutionStatus];
    });

  //Q4

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22decomissioning-resources%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q4_ExecutionStatus];
    });

  //Q5

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22select-service%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q5_ExecutionStatus];
    });

  //Q6

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22type-size-number-resources%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q6_ExecutionStatus];
    });

  //Q7

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22pricing-model%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q7_ExecutionStatus];
    });

  //Q8

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22data-transfer%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q8_ExecutionStatus];
    });

  //Q9

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22manage-demand-resources%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q9_ExecutionStatus];
    });

  //Q10

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22evaluate-new-services%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q10_ExecutionStatus];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22evaluate-cost-effort%22,%22PillarId%22:%22costOptimization%22%7D`
    )
    .reply(() => {
      return [200, Cost_Optimization_Q11_ExecutionStatus];
    });

  //Operational Excellence
  //Q1
  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/questions?Filters=%7B%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q1];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22priorities%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q1_Summaries];
    });

  //Q2

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22ops-model%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q2_ExecutionStatus];
    });

  //Q3

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22org-culture%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q3_ExecutionStatus];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22telemetry%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q4_ExecutionStatus];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22dev-integ%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q5_ExecutionStatus];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22mit-deploy-risks%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q6_ExecutionStatus];
    });

  //Q7

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22ready-to-support%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q7_ExecutionStatus];
    });

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22workload-health%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q8_ExecutionStatus];
    });

  //Q9

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22operations-health%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q9_ExecutionStatus];
    });

  //Q10

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22event-response%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q10_ExecutionStatus];
    });

  // Q11

  mock
    .onGet(
      `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/check-summary?Filters=%7B%22Card%22:%22Question%22,%22QuestionId%22:%22evolve-ops%22,%22PillarId%22:%22operationalExcellence%22%7D`
    )
    .reply(() => {
      return [200, Operational_Excellence_Q11_ExecutionStatus];
    });

  //Edit View
  mock.onGet(`${WAR_ASSESSMENT_METADATA_URL}`).reply(() => {
    return [200, Edit_Workload_Summaries_Metadata];
  });

  mock
    .onGet(
      `${ORGANIZATION_BASE_URL}8deba6a6-38f8-4a5c-8700-4942e280b2a9/departments/`
    )
    .reply(() => {
      return [200, Edit_Workload_Acc_Details];
    });

  mock.onGet(`${WAR_ASSESSMENT_LIST_URL}`).reply(() => {
    return [200, Edit_Workload_Summaries];
  });

  mock
    .onGet(
      `war-assessment/workloads?Filters=%7B%22Status%22:%22COMPLETED%22%7D&Limit=10&PageNumber=1`
    )
    .reply(() => {
      return [200, Comleted_Workload_List_Response];
    });

  //autonomous checks
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_uppercase_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check1];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22secret_age_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check2];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22security_hub_enable_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check3];
  //   });

  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_user_inline_policy_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check4];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22unused_function_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check5];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_lowercase_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check6];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_policy_cis_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check7];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_age_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check8];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22kms_cmk_keystate_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check9];
  //   });

  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_length_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check10];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_support_role_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check11];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_multiple_active_accesskey_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check12];
  //   });

  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_user_first_access_key_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check13];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22security_hub_cis_enable_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check14];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_symbol_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check15];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_user_second_access_key_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check16];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_role_policies_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check17];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22securityhub_foundational_security_enable_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check18];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22no_root_account_access_key_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check19];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_user_access_key_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check20];
  //   });

  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22cognito_identity_pool_password_policy%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check21];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22cognito_temporary_password_age_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check22];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_assume_role_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check23];
  //   });
  // mock
  //   .onGet(
  //     `${WAR_ASSESSMENT_Details_URL}${PENDING_WORKLOAD_ID}/findings?Filters=%7B%22CheckIds%22:%5B%22iam_password_number_check%22%5D,%22PillarIds%22:%5B%22security%22%5D,%22QuestionIds%22:%5B%22securely-operate%22%5D,%22Offset%22:0,%22Limit%22:10,%22KeywordSearch%22:%5B%5D%7D`
  //   )
  //   .reply(() => {
  //     return [200, Security_Check24];
  //   });

  // supress

  const supressApi = new RegExp(`${WAR_ASSESSMENT_Details_URL}finding`);

  mock.onPut(supressApi).reply(() => {
    return [200, PENDING_WORKLOAD_ID];
  });

  // Create New Review WAFR
  mock.onPost(`${WAR_ASSESSMENT_Details_URL}`).reply(async (config) => {
    const data = config.data && JSON.parse(config.data);
    let assessments = await getStorage("ASSESSMENTS");

    let review = await createReview(data);
    assessments.WorkloadSummaries.push(review);

    await setStorage("ASSESSMENTS", assessments);

    return [
      200,
      {
        WorkloadArn: `arn:aws:wellarchitected:${data.RegionCode}:688736627613:workload/${review.WorkloadId}`,
        WorkloadId: review.WorkloadId,
      },
    ];
  });

  const deleteWorkloadApi = new RegExp(`${WAR_ASSESSMENT_Details_URL}.+`);

  mock.onDelete(deleteWorkloadApi).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];

    return [200, id];
  });

  const assessmentWorkloadOperationalExcellenceQ11 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/evolve-ops`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ11).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q11
      : NewWorkload_Operational_Excellence_Q11;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ10 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/event-response`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ10).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q10
      : NewWorkload_Operational_Excellence_Q10;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ9 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/operations-health`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ9).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q9
      : NewWorkload_Operational_Excellence_Q9;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ8 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/workload-health`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ8).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q8
      : NewWorkload_Operational_Excellence_Q8;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ7 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/ready-to-support`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ7).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q7
      : NewWorkload_Operational_Excellence_Q7;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ6 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/mit-deploy-risks`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ6).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q6
      : NewWorkload_Operational_Excellence_Q6;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ5 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/dev-integ`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ5).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q5
      : NewWorkload_Operational_Excellence_Q5;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ4 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/telemetry`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ4).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q4
      : NewWorkload_Operational_Excellence_Q4;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ3 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/org-culture`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ3).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q3
      : NewWorkload_Operational_Excellence_Q3;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ2 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/ops-model`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ2).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q2
      : NewWorkload_Operational_Excellence_Q2;

    return [200, result];
  });

  const assessmentWorkloadOperationalExcellenceQ1 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/priorities`
  );

  mock.onGet(assessmentWorkloadOperationalExcellenceQ1).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Operational_Excellence_Q1_ExecutionStatus
      : NewWorkload_Operational_Excellence_Q1;

    return [200, result];
  });

  const assessmentWorkloadSustainabilityQ6 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/sus_dev`
  );

  mock.onGet(assessmentWorkloadSustainabilityQ6).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Sustainability_Q6
      : NewWorkload_Sustainability_Q6;

    return [200, result];
  });

  const assessmentWorkloadSustainabilityQ5 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/sus_hardware`
  );

  mock.onGet(assessmentWorkloadSustainabilityQ5).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Sustainability_Q5
      : NewWorkload_Sustainability_Q5;

    return [200, result];
  });

  const assessmentWorkloadSustainabilityQ4 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/sus_data`
  );

  mock.onGet(assessmentWorkloadSustainabilityQ4).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Sustainability_Q4
      : NewWorkload_Sustainability_Q4;

    return [200, result];
  });

  const assessmentWorkloadSustainabilityQ3 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/sus_software`
  );

  mock.onGet(assessmentWorkloadSustainabilityQ3).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Sustainability_Q3
      : NewWorkload_Sustainability_Q3;

    return [200, result];
  });

  const assessmentWorkloadSustainabilityQ2 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/sus_user`
  );

  mock.onGet(assessmentWorkloadSustainabilityQ2).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Sustainability_Q2
      : NewWorkload_Sustainability_Q2;

    return [200, result];
  });

  const assessmentWorkloadSustainabilityQ1 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/sus_region`
  );

  mock.onGet(assessmentWorkloadSustainabilityQ1).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Sustainability_Q1_Summaries
      : NewWorkload_Sustainability_Q1;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ11 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/evaluate-cost-effort`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ11).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q11
      : NewWorkload_Cost_Optimization_Q11;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ10 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/evaluate-new-services`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ10).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q10
      : NewWorkload_Cost_Optimization_Q10;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ9 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/manage-demand-resources`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ9).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q9
      : NewWorkload_Cost_Optimization_Q9;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ8 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/data-transfer`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ8).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q8
      : NewWorkload_Cost_Optimization_Q8;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ7 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/pricing-model`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ7).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q7
      : NewWorkload_Cost_Optimization_Q7;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ6 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/type-size-number-resources`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ6).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q6
      : NewWorkload_Cost_Optimization_Q6;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ5 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/select-service`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ5).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q5
      : NewWorkload_Cost_Optimization_Q5;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ4 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/decomissioning-resources`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ4).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q4
      : NewWorkload_Cost_Optimization_Q4;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ3 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/monitor-usage`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ3).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q3
      : NewWorkload_Cost_Optimization_Q3;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ2 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/govern-usage`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ2).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q2
      : NewWorkload_Cost_Optimization_Q2;

    return [200, result];
  });

  const assessmentWorkloadCostOptimizationQ1 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/cloud-financial-management`
  );

  mock.onGet(assessmentWorkloadCostOptimizationQ1).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Cost_Optimization_Q1_Summaries
      : NewWorkload_Cost_Optimization_Q1;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ13 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/planning-for-recovery`
  );

  mock.onGet(assessmentWorkloadReliabilityQ13).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q13 : NewWorkload_Reliability_Q13;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ12 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/testing-resiliency`
  );

  mock.onGet(assessmentWorkloadReliabilityQ12).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q12 : NewWorkload_Reliability_Q12;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ11 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/withstand-component-failures`
  );

  mock.onGet(assessmentWorkloadReliabilityQ11).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q11 : NewWorkload_Reliability_Q11;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ10 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/fault-isolation`
  );

  mock.onGet(assessmentWorkloadReliabilityQ10).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q10 : NewWorkload_Reliability_Q10;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ9 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/backing-up-data`
  );

  mock.onGet(assessmentWorkloadReliabilityQ9).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q9 : NewWorkload_Reliability_Q9;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ8 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/tracking-change-management`
  );

  mock.onGet(assessmentWorkloadReliabilityQ8).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q8 : NewWorkload_Reliability_Q8;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ7 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/adapt-to-changes`
  );

  mock.onGet(assessmentWorkloadReliabilityQ7).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q7 : NewWorkload_Reliability_Q7;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ6 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/monitor-aws-resources`
  );

  mock.onGet(assessmentWorkloadReliabilityQ6).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q6 : NewWorkload_Reliability_Q6;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ5 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/mitigate-interaction-failure`
  );

  mock.onGet(assessmentWorkloadReliabilityQ5).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q5 : NewWorkload_Reliability_Q5;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ4 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/prevent-interaction-failure`
  );

  mock.onGet(assessmentWorkloadReliabilityQ4).reply((config) => {
    const url = config.url.split("/");

    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q4 : NewWorkload_Reliability_Q4;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ3 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/service-architecture`
  );

  mock.onGet(assessmentWorkloadReliabilityQ3).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q3 : NewWorkload_Reliability_Q3;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ2 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/planning-network-topology`
  );

  mock.onGet(assessmentWorkloadReliabilityQ2).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Reliability_Q2 : NewWorkload_Reliability_Q2;

    return [200, result];
  });

  const assessmentWorkloadReliabilityQ1 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/manage-service-limits`
  );

  mock.onGet(assessmentWorkloadReliabilityQ1).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Reliability_Q1_Summaries
      : NewWorkload_Reliability_Q1;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ8 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/tradeoffs-performance`
  );

  mock.onGet(assessmentWorkloadPerformanceQ8).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q8
      : NewWorkload_Performance_Eff_Q8;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ7 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/monitor-instances-post-launch`
  );

  mock.onGet(assessmentWorkloadPerformanceQ7).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q7
      : NewWorkload_Performance_Eff_Q7;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ6 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/continue-having-appropriate-resource-type`
  );

  mock.onGet(assessmentWorkloadPerformanceQ6).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q6
      : NewWorkload_Performance_Eff_Q6;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ5 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/select-network`
  );

  mock.onGet(assessmentWorkloadPerformanceQ5).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q5
      : NewWorkload_Performance_Eff_Q5;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ4 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/right-database-solution`
  );

  mock.onGet(assessmentWorkloadPerformanceQ4).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q4_Summaries
      : NewWorkload_Performance_Eff_Q4;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ3 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/right-storage-solution`
  );

  mock.onGet(assessmentWorkloadPerformanceQ3).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q3
      : NewWorkload_Performance_Eff_Q3;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ2 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/select-compute`
  );

  mock.onGet(assessmentWorkloadPerformanceQ2).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Q2
      : NewWorkload_Performance_Eff_Q2;

    return [200, result];
  });

  const assessmentWorkloadPerformanceQ1 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/performing-architecture`
  );

  mock.onGet(assessmentWorkloadPerformanceQ1).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Performance_Efficiency_Check_Q1_ExecutionStatus
      : NewWorkload_Performance_Eff_Q1;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ11 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/application-security`
  );
  mock.onGet(assessmentWorkloadSecurityQ11).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];

    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q11 : NewWorkload_Security_Q11;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ10 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/incident-response`
  );
  mock.onGet(assessmentWorkloadSecurityQ10).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q10 : NewWorkload_Security_Q10;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ9 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/protect-data-transit`
  );
  mock.onGet(assessmentWorkloadSecurityQ9).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q9 : NewWorkload_Security_Q9;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ8 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/protect-data-rest`
  );
  mock.onGet(assessmentWorkloadSecurityQ8).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q8 : NewWorkload_Security_Q8;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ7 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/data-classification`
  );
  mock.onGet(assessmentWorkloadSecurityQ7).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q7 : NewWorkload_Security_Q7;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ6 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/protect-compute`
  );
  mock.onGet(assessmentWorkloadSecurityQ6).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q6 : NewWorkload_Security_Q6;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ5 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+question/network-protection`
  );
  mock.onGet(assessmentWorkloadSecurityQ5).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q5 : NewWorkload_Security_Q5;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ4 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/detect-investigate-events`
  );
  mock.onGet(assessmentWorkloadSecurityQ4).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q4 : NewWorkload_Security_Q4;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ3 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/permission`
  );
  mock.onGet(assessmentWorkloadSecurityQ3).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q3 : NewWorkload_Security_Q3;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ2 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/identities`
  );
  mock.onGet(assessmentWorkloadSecurityQ2).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId ? Security_Pillar_Q2 : NewWorkload_Security_Q2;

    return [200, result];
  });

  const assessmentWorkloadSecurityQ1 = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/question/securely-operate`
  );

  mock.onGet(assessmentWorkloadSecurityQ1).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 3];
    const isPendingId = id === PENDING_WORKLOAD_ID;
    let result = isPendingId
      ? Security_MockData_Securely_Operate
      : NewWorkload_Security_Q1;

    return [200, result];
  });

  const assessmentWorkloadQuestionsEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/questions`
  );

  mock.onGet(assessmentWorkloadQuestionsEndpoint).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let completeFilterParams = JSON.parse(
      decodeURI(config.url.split("Filters=")[1])
    );

    const isPendingId = id === PENDING_WORKLOAD_ID;

    const pendingWorkloadQuestionListMap = {
      security: Security_Question_List,
      performance: Performance_Efficiency_Q1,
      sustainability: Sustainability_Q1,
      reliability: Reliability_Q1,
      costOptimization: Cost_Optimization_Q1,
      operationalExcellence: Operational_Excellence_Q1,
    };

    const newWorkloadQuestionListMap = {
      security: NewWorkload_Security_Question_List,
      performance: NewWorkload_Performance_Eff_Question_List,
      reliability: NewWorkload_Reliability_Question_List,
      costOptimization: NewWorkload_Cost_Optimization_Question_List,
      sustainability: NewWorkload_Sustainability_Question_List,
      operationalExcellence: NewWorkload_Operational_Excellence_Question_List,
    };

    let result = isPendingId
      ? pendingWorkloadQuestionListMap[completeFilterParams.PillarId]
      : newWorkloadQuestionListMap[completeFilterParams.PillarId];

    return [200, result];
  });

  const assessmentWorkloadCheckSummaryEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+/check-summary`
  );

  mock.onGet(assessmentWorkloadCheckSummaryEndpoint).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let completeFilterParams = JSON.parse(
      decodeURI(config.url.split("Filters=")[1])
    );
    const isPendingId = id === PENDING_WORKLOAD_ID;
    const isAcmeAppDev = id === AcmeApp_Dev_WorkloadId;

    const newWorkloadCheckSummaryMap = {
      Workload: NewWorkload_Checks_Summary_MockData,
      reliability: NewWorkload_Reliability_Checks_MockData,
      sustainability: NewWorkload_Sustainability_Checks_MockData,
      operationalExcellence: NewWorkload_Operational_Excellence_Checks_MockData,
      costOptimization: NewWorkload_CostOptimization_Checks_MockData,
      security: NewWorkload_Checks_Security_Mockdata,
      performance: NewWorkload_Check_Performace_Efficiency_MockData,
    };

    const pendingWorkloadCheckSummaryMap = {
      Workload: Workload_Checks_Summary_MockData,
      reliability: Workload_Reliability_Checks_MockData,
      sustainability: Workload_Sustainability_Checks_MockData,
      operationalExcellence: Workload_Operational_Excellence_Checks_MockData,
      costOptimization: Workload_CostOptimization_Checks_MockData,
      security: Workload_Checks_Security_Mockdata,
      performance: Workload_Check_Performace_Efficiency_MockData,
    };

    const acmeAppDevWorkloadCheckSummaryMap = {
      Workload: AcmeAppDev_Workload_Checks_Summary_MockData,
      reliability: AcmeAppDev_Workload_Reliability_Checks_MockData,
      sustainability: AcmeAppDev_Workload_Sustainability_Checks_MockData,
      operationalExcellence:
        AcmeAppDev_Workload_Operational_Excellence_Checks_MockData,
      costOptimization: AcmeAppDev_Workload_CostOptimization_Checks_MockData,
      security: AcmeAppDev_Workload_Checks_Security_Mockdata,
      performance: AcmeAppDev_Workload_Check_Performace_Efficiency_MockData,
    };
    console.log(completeFilterParams.Card);
    if (completeFilterParams.Card === CARD_WORKLOAD) {
      let result = newWorkloadCheckSummaryMap[completeFilterParams.Card];
      if (isPendingId) {
        result = pendingWorkloadCheckSummaryMap[completeFilterParams.Card];
      }
      if (isAcmeAppDev) {
        result = acmeAppDevWorkloadCheckSummaryMap[completeFilterParams.Card];
      }
      console.log({ result });
      return [200, result];
    } else if (completeFilterParams.Card === CARD_PILLAR) {
      let result = newWorkloadCheckSummaryMap[completeFilterParams.PillarId];
      if (isPendingId) {
        result = pendingWorkloadCheckSummaryMap[completeFilterParams.PillarId];
      }
      if (isAcmeAppDev) {
        result =
          acmeAppDevWorkloadCheckSummaryMap[completeFilterParams.PillarId];
      }
      console.log({ result });
      return [200, result];
    } else if (completeFilterParams.Card === CARD_QUESTION && !isPendingId) {
      return [200, NewWorkload_Question_Check_MockData];
    }
  });

  const assessmentDetailEndpoint = new RegExp(
    `${WAR_ASSESSMENT_Details_URL}.+`
  );

  mock.onGet(assessmentDetailEndpoint).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];

    let assessments = await getStorage("ASSESSMENTS");

    let assessment = assessments.WorkloadSummaries.find(
      (workload) => workload.WorkloadId === id
    );
    let review = {};

    if (id === AcmeApp_Dev_WorkloadId) {
      review = AcmeApp_Dev_MOCK;
    } else if (id === AcmeApp_Staging_WorkloadId) {
      review = AcmeApp_Staging_MOCK;
    } else if (id === AcmeApp_Prod_WorkloadId) {
      review = AcmeApp_Prod_MOCK;
    } else if (id === Acme_Research_App_WorkloadId) {
      review = Acme_Research_App_Mock;
    } else {
      review = updateReview(assessment);
    }

    return [200, review];
  });
};
